<template>
    <div class="data-table-filter-select">
        <b-form-select v-model="localValue"
                       :options="localOptions"
                       @change="valueSelected"/>
    </div>
</template>

<script>
import Vue from 'vue'
import Api from '@/providers/Api'
import * as _ from 'lodash'

/**
 * A wrapper for a select input that implements behaviors similar to the DataTableFilterMultiselect component.
 * Emits an item-selected event (with a value/text object), which can be used e.g. to update a page title.
 * It also handles the reset action on a filter form, via the resetValue method.
 */

export default Vue.extend({
    name: 'DataTableFilterSelect',
    props: {
        value: {
            required: true
        },
        options: {   // optional: specify options statically - format: [{value: ..., text: '...'}, ...]
            type: Array
        },
        apiTable: {  // the table/controller path from which to fetch options from the API (e.g. 'company' or 'company-user')
            type: String,
            required: false
        },
        labelField: {  // the field to use to fetch a display label for each option item (e.g. 'name')
            type: String,
            default: 'name'
        }
    },
    data() {
        return {
            localValue: null,
            localOptions: [],
        }
    },
    methods: {
        // called when a value (ID) is selected
        async valueSelected(id, initializing = false) {
            // don't emit events on initialization (prevent double refresh in DataTable)
            // NB: to display a "null/any" option, its value must be null, NOT undefined
            // (b-form-select emits an event with value=undefined on init)
            if (id !== undefined && !initializing) {
                this.localValue = id
                const item = this.findOption(id)
                this.$emit('item-selected', item)
                this.$emit('input', this.localValue)
            }
        },
        // called by DataTable::resetFilters
        // NB: id is not necessarily null (e.g. filter with defaultValue)
        resetValue(id, initializing) {
            this.valueSelected(id, initializing)
        },
        async loadOptions() {
            if (this.options) {
                this.localOptions = this.options
            } else {
                const items = await Api.getAllItems(this, this.apiTable)
                const items_sorted = _.sortBy(items, this.labelField)
                this.localOptions = _.map(items_sorted, (item) => {
                    return { value: item.id, text: item[this.labelField] }
                })
            }
            this.localValue = this.value
            // emit event to allow e.g. updating list title based on selected item
            const item = this.findOption(this.localValue)
            if (item) {
                this.$emit('item-selected', item)
            }
        },
        findOption(id) {
            return _.find(this.localOptions, (opt) => {
                return opt.value === +id
            })
        },
    },
    mounted() {
        this.loadOptions()
    },
})
</script>
